import { LoadableComponent } from '@board/ui/LoadableComponent';
import React from 'react';

const Component = React.lazy(() => import('./PublicRoutes'));
export const PublicRoutes = () => (
  <LoadableComponent>
    <Component />
  </LoadableComponent>
);
